import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

/**
 * Given a taxonomy from the API creates a map for quick lookup.
 * @param {array} taxonomy - Array of taxonomy objects.
 * @returns {object}
 */
export default function makeTaxonomyMap(taxonomy) {
  const taxMap = {};
  taxonomy.forEach((tax) => {
    taxMap[tax.id] = {
      id: tax.id,
      name: DOMPurify.sanitize(parse(tax.name)),
      slug: tax.slug,
      parent: tax.parent,
    };
  });
  return taxMap;
}
